import Vue from 'vue'

const ANALYSIS = {
	IMAGE_OCR: (postId, src) => {
		return Vue.$api.get('/post-analysis/' + postId + '/image/ocr/', {
			params: { src: src },
		})
	},
	IMAGE_EXPRESION: (postId, src) => {
		return Vue.$api.get('/post-analysis/' + postId + '/image/expression', {
			params: { src: src },
		})
	},
	IMAGE_LABELS: (postId, src) => {
		return Vue.$api.get('/post-analysis/' + postId + '/image/labels', {
			params: { src: src },
		})
	},

	HASHTAG_SENTIMENT: postId => {
		return Vue.$api.get('/post-analysis/' + postId + '/hashtag/sentiment')
	},
	HASHTAG_CATEGORIES: postId => {
		return Vue.$api.get('/post-analysis/' + postId + '/hashtag/classify')
	},
	HASHTAG_ENTITY: postId => {
		return Vue.$api.get('/post-analysis/' + postId + '/hashtag/entity')
	},

	IMAGE: postId => {
		return Vue.$api.get('/post-analysis/' + postId + '/image')
	},

	HASHTAG: postId => {
		return Vue.$api.get('/post-analysis/' + postId + '/hashtag')
	},
}

export default ANALYSIS
